import { render, staticRenderFns } from "./exercisesSAQ.vue?vue&type=template&id=05103e75&scoped=true"
import script from "./exercisesSAQ.vue?vue&type=script&lang=js"
export * from "./exercisesSAQ.vue?vue&type=script&lang=js"
import style0 from "./exercisesSAQ.vue?vue&type=style&index=0&id=05103e75&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05103e75",
  null
  
)

export default component.exports